/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PersonPasswordUpdateRequest model module.
 * @module model/PersonPasswordUpdateRequest
 * @version v0
 */
export default class PersonPasswordUpdateRequest {
  /**
   * Constructs a new <code>PersonPasswordUpdateRequest</code>.
   * @alias module:model/PersonPasswordUpdateRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PersonPasswordUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PersonPasswordUpdateRequest} obj Optional instance to populate.
   * @return {module:model/PersonPasswordUpdateRequest} The populated <code>PersonPasswordUpdateRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PersonPasswordUpdateRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('idAsString'))
        obj.idAsString = ApiClient.convertToType(data['idAsString'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
PersonPasswordUpdateRequest.prototype.id = undefined;

/**
 * @member {String} password
 */
PersonPasswordUpdateRequest.prototype.password = undefined;

/**
 * @member {String} idAsString
 */
PersonPasswordUpdateRequest.prototype.idAsString = undefined;

